import { Injectable } from '@angular/core';
import { TableColumn } from '@app/shared/table';
import { SplitColumnNameTooltipPipe } from '@app/shared/table/pipes/split-column-name-tooltip.pipe';

import * as XLSX from 'sheetjs_xlsx';
@Injectable()
export class UtilityService {

  exportListToXLSX(data: any[], columns: TableColumn[], filename: string) {
    const pipe = new SplitColumnNameTooltipPipe();
    const __columns = columns.filter((col) => col.exportXLSX);
    const columnsSheet = __columns.map((col) => pipe.transform(col.name));
    const __dataSource = data.map((row) => {
      return __columns.map((col) => {
        // se non c'è il prop vuole dire che ha usato il transform
        if (!col.prop) {
          return col.pipe.transform(row);
        }
        // anche qui potrebbe aver usato il tansform
        return col.pipe ? col.pipe.transform(row[col.prop]) : row[col.prop];
      });
    });
    const __data = [columnsSheet].concat(__dataSource);
    const ws: XLSX.WorkSheet = XLSX.utils.aoa_to_sheet(__data, {});
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, `export-${filename}.xlsx`);
  }
}
